import appGlobalScript from '/sys_apps_01/jenkins/workspace/PresentationEnablement/LOWER-ENVIRONMENT/NetStorage/forms-ui/create-forms-ui-artifact-version-from-package-json-and-upload/repo/src/global/start.ts';
export const globalScripts = appGlobalScript;
